var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 7.3464H10M5.83333 10.2631H12.5M5.83333 15.2631V17.2093C5.83333 17.6534 5.83333 17.8754 5.92436 17.9894C6.00352 18.0886 6.12356 18.1463 6.25045 18.1461C6.39636 18.146 6.56973 18.0073 6.91646 17.7299L8.90434 16.1396C9.31043 15.8147 9.51347 15.6523 9.73957 15.5368C9.94017 15.4343 10.1537 15.3594 10.3743 15.3141C10.6231 15.2631 10.8831 15.2631 11.4031 15.2631H13.5C14.9001 15.2631 15.6002 15.2631 16.135 14.9906C16.6054 14.7509 16.9878 14.3684 17.2275 13.898C17.5 13.3633 17.5 12.6632 17.5 11.2631V6.76306C17.5 5.36293 17.5 4.66286 17.2275 4.12809C16.9878 3.65768 16.6054 3.27523 16.135 3.03555C15.6002 2.76306 14.9001 2.76306 13.5 2.76306H6.5C5.09987 2.76306 4.3998 2.76306 3.86502 3.03555C3.39462 3.27523 3.01217 3.65768 2.77248 4.12809C2.5 4.66286 2.5 5.36293 2.5 6.76306V11.9297C2.5 12.7047 2.5 13.0922 2.58519 13.4101C2.81635 14.2728 3.49022 14.9467 4.35295 15.1779C4.67087 15.2631 5.05836 15.2631 5.83333 15.2631Z",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.50e2bf4e46bbd03385a845abb20c04a8.svg";
export { ForwardRef as ReactComponent };